import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MetaGuard } from 'meta'
import { SegmentTagMap } from 'src/app/shared/analytics/models/segment-tag-map.model'
import { AthletesListComponent, ATHLETE_LIST_TAG } from './athletes-list/athletes-list.component'
import { AthletesListResolver } from './athletes-list/athletes-list.resolver'
import { CollectionsResolver } from '../collections/collections.resolver'
import { EntityHubSmartComponent } from '../entity-hub/entity-hub-smart.component'
import { EntityHubContentExperimentComponent } from '../entity-hub/entity-hub-content-experiment.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: AthletesListComponent,
        data: {
          shouldShowEventTicker: true,
          segment: ATHLETE_LIST_TAG
        },
        canActivate: [MetaGuard],
        resolve: { athletes: AthletesListResolver }
      },
      {
        path: ':nodeId',
        component: EntityHubSmartComponent,
        canActivate: [MetaGuard],
        resolve: { collection: CollectionsResolver },
        children: [
          {
            path: '',
            component: EntityHubContentExperimentComponent,
            canActivate: [MetaGuard],
            data: {
              shouldShowAdSkin: false,
              noTopScroll: true,
              shouldShowEventTicker: true,
              segment: SegmentTagMap.COLLECTIONS_TAB_VIEW
            }
          },
          {
            path: ':tab',
            component: EntityHubContentExperimentComponent,
            canActivate: [MetaGuard],
            data: {
              shouldShowAdSkin: false,
              noTopScroll: true,
              shouldShowEventTicker: true,
              segment: SegmentTagMap.COLLECTIONS_TAB_VIEW
            }
          }
        ],
        data: {
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          segment: SegmentTagMap.COLLECTIONS_VIEW
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class PeopleRoutingModule {}
